/**
 * SINGLE SOURCE OF TRUTH FOR SUPPORTED LANGUAGES
 * 
 * This file defines all supported languages and their metadata.
 * Import this file everywhere instead of hardcoding language arrays.
 */

const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    locale: 'en-US',
    flag: '🇺🇸',
    rtl: false
  },
  {
    code: 'es', 
    name: 'Spanish',
    nativeName: 'Español',
    locale: 'es-ES',
    flag: '🇪🇸',
    rtl: false
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    locale: 'fr-FR',
    flag: '🇫🇷',
    rtl: false
  },
  {
    code: 'ja',
    name: 'Japanese',
    nativeName: '日本語',
    locale: 'ja-JP',
    flag: '🇯🇵',
    rtl: false
  }
];

const LANGUAGE_CONFIG = {
  // Default/fallback language
  defaultLanguage: 'en',
  
  // All supported languages
  supportedLanguages: SUPPORTED_LANGUAGES,
  
  // Quick access helper methods
  getLanguageCodes() {
    return this.supportedLanguages.map(lang => lang.code);
  },
  
  getLanguageByCode(code) {
    return this.supportedLanguages.find(lang => lang.code === code);
  },
  
  isSupported(code) {
    return this.supportedLanguages.some(lang => lang.code === code);
  },
  
  getDisplayName(code) {
    const lang = this.getLanguageByCode(code);
    return lang ? lang.nativeName : code;
  },
  
  getLocale(code) {
    const lang = this.getLanguageByCode(code);
    return lang ? lang.locale : 'en-US';
  },
  
  // For backward compatibility - just return array of codes
  getLanguageArray() {
    return this.getLanguageCodes();
  }
};

// Export for both Node.js and browser environments
if (typeof module !== 'undefined' && module.exports) {
  // Node.js environment
  module.exports = LANGUAGE_CONFIG;
} else if (typeof window !== 'undefined') {
  // Browser environment
  window.LANGUAGE_CONFIG = LANGUAGE_CONFIG;
}
